import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ModalGenericComponent } from '../../../../../shared/components/modal-generic/modal-generic.component';
import { MIN_STATUS } from '../../../../../shared/utils/constants';
import { ConfirmationService } from '../../../../../vass-core/components/modal/confirmation.service';
import { AppraisalModel } from '../../../../models/appraisal.model';

@Component({
  selector: 'app-simple-note',
  templateUrl: './simple-note.component.html',
  styleUrls: ['./simple-note.component.scss'],
  standalone: false,
})
export class SimpleNoteComponent implements OnInit, OnChanges {
  @Output() emitHasSimpleNote: EventEmitter<boolean> = new EventEmitter();
  @Output() emitMorgageAprraisalFile: EventEmitter<boolean> = new EventEmitter();
  @Output() emitUploadFile: EventEmitter<any> = new EventEmitter();

  @Input() appraisal: AppraisalModel;
  @Input() status: number;

  public hasSimpleNote: boolean;
  public minStatus = MIN_STATUS;

  constructor(
    private confirmationService: ConfirmationService,
    private translate: TranslateService,
  ) {}

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.appraisal && changes.appraisal.currentValue) {
      this.hasSimpleNote = this.appraisal.mortgagesAppraisalData.simpleNote;
    }
  }

  public hasSimpleNoteChanged() {
    this.emitHasSimpleNote.emit(this.hasSimpleNote);
  }

  openModal(id: string) {
    const data = {
      message: this.translate.instant(`documentation.info_${id}`),
      txtButton: this.translate.instant('btn_aceptar'),
    };
    const options: Object = {
      header: this.translate.instant(`documentation.name_${id}`),
      showHeader: true,
      closeOnEscape: true,
      closable: true,
      styleClass: 'modal-class',
      cancelButton: false,
      acceptButton: false,
    };

    this.confirmationService.confirm(<any>{
      component: ModalGenericComponent,
      options: options,
      data: data,
      accept: (data) => {},
      reject: () => {},
    });
  }

  openModalUploadFile() {
    this.emitUploadFile.emit();
  }
}
